<template>
  <v-dialog max-width="440" :value="visible" content-class="rounded-10" style="z-index: 15" @input="$emit('input', $event)">
    <v-sheet class="rounded-10 px-2 px-md-4 py-4 py-md-10 d-flex flex-column align-center" color="#f7f2f7">
      <img src="@/assets/warning.png" class="icon" />

      <v-container fluid>
        <p class="text-center px-1 text-body-1">
          인스타그램,카카오톡 등에서 <br />
          인앱브라우저를 이용시 서비스 오류가 <br />발생할 수 있습니다<br />
          (회원가입 오류, 결제 오류 등).<br />
          원활한 서비스를 위해 외부 브라우저를<br />
          이용해 주시기 바랍니다.<br /><br />
          - 외부 브라우저: 사파리, 크롬
        </p>
      </v-container>

      <v-container fluid class="d-flex justify-center mt-6">
        <v-btn color="#d9bddd" class="dialog_btn rounded-2 ml-2" style="font-size: 20px" width="35%" depressed @click="confirmClick" large> 확인 </v-btn>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    confirmClick() {
      this.$emit("confirm")
    },
  },
}
</script>
<style scoped>
.icon {
  width: 60px;
  height: 60px;
}
.dialog_btn {
  border: 2px solid #dadada !important;
  font-size: 16px;
}
::v-deep .v-btn:not(.v-btn--disabled) {
  color: rgb(71, 71, 71);
}
</style>
